/* eslint-disable camelcase */
import React, {
  useEffect, useState,
} from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Modal, Button } from 'antd';

import {
  getWalletsAggregatedRollingReserve,
  fetchWalletOverview,
  fetchSettlementReportSummary,
  markSettlementReportsAsSettled,
  sendSettlementReportSummary,
} from '../../redux/actions/Data';
import { walletColumns } from './Columns';
import WalletOverview from './WalletOverview';
import TransactionSummary from './TransactionSummary';
import SettlementReport from './SettlementReport';
import { fetchTransactionSummary } from '../../redux/actions/Transactions';
import { dateAndTimeRangeQueriesArray } from '../../util/lib';
import SettlementReportSummary from '../SettlementReports/SettlementReportSummary';
import { TransactionStatuses } from '../../constants/System';
import moment from 'moment';

const Wallets = ({ selectedMerchant }) => {
  const dispatch = useDispatch();
  const { timezone } = useSelector(({ settings }) => settings);
  let { COLLECTIONFAILED: tsCollectionFailed, loading: loadingTSFailed } = useSelector(({ transactions }) => transactions.transactionSummaryFailed);
  let { COLLECTIONCOMPLETED: tsCollectionCompleted, loading: loadingTSCompleted } = useSelector(({ transactions }) => transactions.transactionSummarySuccess);

  const wallets = [
    {
      _id: '1',
      code: 'USD',
      name: 'US Dollar',
    },
    {
      _id: '2',
      code: 'EUR',
      name: 'Euro',
    },
    {
      _id: '3',
      code: 'UGX',
      name: 'Ugandan Shilling',
    },
    {
      _id: '4',
      code: 'KES',
      name: 'Kenyan Shilling',
    },
    {
      _id: '5',
      code: 'TZS',
      name: 'Tanzanian Shilling',
    },
    {
      _id: '6',
      code: 'RWF',
      name: 'Rwandan Franc',
    }
  ]

  const {
    data: walletsAGGRReserve,
    loading: loadingWalletsAggregatedRollingReserve,
  } = useSelector(({ data }) => data.walletsAGGRollingReserve);

  const {
    data: walletOverview,
    loading: loadingWalletOverview,
  } = useSelector(({ data }) => data.walletOverview);

  const {
    data: settlementReportSummary,
    loading: loadingSettlementReportSummary,
  } = useSelector(({ data }) => data.settlementReportSummary);

  const {
    updatingSettlementReport,
  } = useSelector(({ data }) => data.settlementReports);

  const [selectedTransactionType, setSelectedTransactionType] = useState(null);
  const [selectedTransactionStatus, setSelectedTransactionStatus] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [childMerchantID, setChildMerchantID] = useState([]);
  const [visibleOverviewModal, setVisibleOverviewModal] = useState(false);
  const [overviewWallet, setOverviewWallet] = useState({});
  const [visibleTransactionSummaryModal, setVisibleTransactionSummaryModal] = useState(false);
  const [transactionSummaryWallet, setTransactionSummaryWallet] = useState({});
  const [visibleSettlementReportCreateModal, setVisibleSettlementReportCreateModal] = useState(
    false,
  );
  const [visibleSettlementReportSummaryModal, setVisibleSettlementReportSummaryModal] = useState(
    false,
  );
  const [settlementReportCreateWallet, setSettlementReportCreateWallet] = useState({});

  useEffect(() => {
    if (selectedMerchant) {
      const queries = [
        `merchant_id=${selectedMerchant._id}`,
        `rolling_reserve=${selectedMerchant.rolling_reserve}`,
        `rolling_reserve_period=${selectedMerchant.rolling_reserve_period}`,
        `card_settlement_period=${selectedMerchant.card_settlement_period || 7}`,
      ];
      const params = queries.join('&');
      dispatch(getWalletsAggregatedRollingReserve(params));
    }
  }, [dispatch]);

  const showWalletOverview = (wallet) => {
    setOverviewWallet(wallet);
    setVisibleOverviewModal(true);
  };

  const closeWalletOverview = () => {
    setVisibleOverviewModal(false);
  };

  const showTransactionSummary = (wallet) => {
    setTransactionSummaryWallet(wallet);
    setVisibleTransactionSummaryModal(true);
  };

  const closeTransactionSummary = () => {
    setVisibleTransactionSummaryModal(false);
  };

  const showSettlementReportCreate = (wallet) => {
    setSettlementReportCreateWallet(wallet);
    setVisibleSettlementReportCreateModal(true);
  };

  const showSettlementReportSummary = () => {
    setVisibleSettlementReportSummaryModal(true);
  };

  const closeSettlementReport = () => {
    setVisibleSettlementReportCreateModal(false);
    setVisibleSettlementReportSummaryModal(false);
    setSettlementReportCreateWallet(null);
  };

  const fetchOverview = () => {
    let queries = [
      `merchant_id=${selectedMerchant?._id}`,
      `is_affiliate=${selectedMerchant.enable_affiliate}`,
      `child_merchant=${childMerchantID}`,
      `transaction_currency=${overviewWallet.code}`,
      `transaction_type=${selectedTransactionType}`,
    ];

    if (dateRange?.length > 1 && dateRange[0] && dateRange[1]) {
      if (dateRange[0]?.length > 9 && dateRange[1]?.length > 9) {
        queries = [
          ...queries,
          ...dateAndTimeRangeQueriesArray(dateRange[0], dateRange[1], timezone),
        ];
      }
    }
    const params = queries.join('&');
    dispatch(fetchWalletOverview(params));
  };

  const fetchSummary = () => {
    let queries = [
      `merchant_id={"$in": ["${selectedMerchant?._id}"]}`,
      `is_affiliate=${selectedMerchant.enable_affiliate}`,
      `child_merchant=${childMerchantID}`,
      `transaction_currency=${transactionSummaryWallet.code}`,
      `transaction_type=${selectedTransactionType}`,
      `transaction_status=${selectedTransactionStatus}`,
    ];

    if (dateRange?.length > 1 && dateRange[0] && dateRange[1]) {
      if (dateRange[0]?.length > 9 && dateRange[1]?.length > 9) {
        queries = [
          ...queries,
          ...dateAndTimeRangeQueriesArray(dateRange[0], dateRange[1], timezone),
        ];
      }
    }

    const params = queries.join('&');
    dispatch(fetchTransactionSummary(params));
  };

  const fetchSettlementSummary = () => {
    let queries = [
      `merchant_id=${selectedMerchant?._id}`,
    ];

    if (dateRange?.length > 1 && dateRange[0] && dateRange[1]) {
      if (dateRange[0]?.length > 9 && dateRange[1]?.length > 9) {
        queries = [...queries, `from=${dateRange[0]}`, `to=${dateRange[1]}`];
      }
    }

    const params = queries.join('&');
    dispatch(fetchSettlementReportSummary(params));
  };

  const tableProps = {
    pagination: false,
    columns: walletColumns(
      loadingWalletsAggregatedRollingReserve,
      showWalletOverview,
      showTransactionSummary,
      showSettlementReportCreate,
      selectedMerchant?.card_settlement_period || 7,
    ),
    dataSource: (walletsAGGRReserve && walletsAGGRReserve.length)
      ? wallets.map((wallet) => {
        const _c = wallet.code;
        const reserve = Number((walletsAGGRReserve.find((el) => el.currency === _c)?.reserve) || 0);
        const total = Number((walletsAGGRReserve.find((el) => el.currency === _c)?.total) || 0);
        const period_months_ago = new Date((walletsAGGRReserve.find((el) => el.currency === _c)?.period_months_ago));
        const period_days_ago = new Date((walletsAGGRReserve.find((el) => el.currency === _c)?.period_days_ago));
        const tplusxReserve = Number((walletsAGGRReserve.find((el) => el.currency === _c)?.tplusxReserve));
        const tplusx = Number((walletsAGGRReserve
          .find((el) => el.currency === _c)?.tplusxTotal) || 0);
        const tplusxPeriod = Number((walletsAGGRReserve
          .find((el) => el.currency === _c)?.tplusxPeriod) || 0);

        return {
          ...wallet,
          reserve,
          totalReserve: reserve + tplusxReserve,
          tplusxReserve,
          total,
          available: (tplusx + total) - (reserve + tplusxReserve),
          tplusx,
          tplusxPeriod,
          period_months_ago,
          period_days_ago,
        };
      })
      : wallets,
  };

  const handleChange = (value, key) => {
    if (key === 'transaction_type') {
      setSelectedTransactionType(value);
    } else if (key === 'transaction_status') {
      setSelectedTransactionStatus(value);
    } else if (key === 'date_range') {
      setDateRange(value);
    } else if (key === 'child_merchant') {
      setChildMerchantID(value);
    }
  };

  const [currencyAsSettled, setCurrencyAsSettled] = useState(null);
  const markSettlementReportsAsSettledByCurrency = (record) => {
    setCurrencyAsSettled(record.code);
    dispatch(markSettlementReportsAsSettled({
      merchant_id: selectedMerchant._id,
      from: dateRange[0],
      to: dateRange[1],
      currency: record.code,
    }));
  };

  const sendSettlementSummary = (record) => {
    dispatch(sendSettlementReportSummary({
      merchant_id: selectedMerchant._id,
      from: dateRange[0],
      to: dateRange[1],
      currency: record.code,
    }));
  };

  return (
    (
      <>
        <div>
          <Button onClick={() => showSettlementReportSummary()}>Settlement Summary</Button>
        </div>
        <Table className="gx-table-responsive" {...tableProps} />
        {overviewWallet
          && (
            <Modal
              title={`${overviewWallet?.code} (${selectedMerchant.name}) - Based on Wallet Transactions`}
              open={visibleOverviewModal}
              okText="Ok"
              onCancel={closeWalletOverview}
              width="75%"
              footer={[
                <Button key="submit" className="gx-w-100" type="dashed" onClick={fetchOverview}>load</Button>,
              ]}
            >
              <WalletOverview {...{
                wallet: overviewWallet,
                handleChange,
                isAffiliate: selectedMerchant.enable_affiliate,
                overview: walletOverview,
                overviewLoading: loadingWalletOverview,
              }}
              />
            </Modal>
          )}
        {transactionSummaryWallet
          && (
            <Modal
              title={`${transactionSummaryWallet?.code} (${selectedMerchant.name}) - Based on Transaction Requests`}
              open={visibleTransactionSummaryModal}
              onCancel={closeTransactionSummary}
              width="75%"
              footer={[
                <Button key="submit" className="gx-w-100" type="dashed" onClick={fetchSummary}>load</Button>,
              ]}
            >
              <TransactionSummary {...{
                wallet: transactionSummaryWallet,
                handleChange,
                isAffiliate: selectedMerchant.enable_affiliate,
                summary: selectedTransactionStatus === TransactionStatuses.FAILED ? tsCollectionFailed : tsCollectionCompleted,
                summaryLoading: loadingTSFailed || loadingTSCompleted,
              }}
              />
            </Modal>
          )}
        {settlementReportCreateWallet
          && (
            <Modal
              open={visibleSettlementReportCreateModal}
              onCancel={closeSettlementReport}
              width="90%"
              footer={null}
              centered
              destroyOnClose
            >
              <SettlementReport {...{
                wallet: settlementReportCreateWallet,
                selectedMerchant,
                handleChange,
                isAffiliate: selectedMerchant.enable_affiliate,
              }}
              />
            </Modal>
          )}

        <Modal
          title={`${selectedMerchant.name} Settlement Summary - Based on Settlement Reports`}
          open={visibleSettlementReportSummaryModal}
          okText="Ok"
          onCancel={closeSettlementReport}
          width="75%"
          footer={[
            <Button key="submit" className="gx-w-100" type="dashed" onClick={fetchSettlementSummary}>load</Button>,
          ]}
          destroyOnClose
        >
          <SettlementReportSummary {...{
            handleChange,
            summary: settlementReportSummary,
            summaryLoading: loadingSettlementReportSummary,
            markAsSettled: markSettlementReportsAsSettledByCurrency,
            sendSettlementSummary,
            isUpdating: updatingSettlementReport,
            currencyAsSettled,
          }}
          />
        </Modal>
      </>
    )
  );
};

Wallets.propTypes = {
  selectedMerchant: PropTypes.object.isRequired,
};

Wallets.defaultProps = {
  selectedMerchant: {},
};

export default Wallets;
